class Page {
    constructor () {
        this.FileWysiwyg();
    }
    FileWysiwyg() {
        $(window).on('load', function(){
            $("a[href*='.pdf']").each(
                function() {
                    $(this).addClass('file');
                });
        });
    }
}

export default Page;